import React from 'react';
import { Link } from 'react-router-dom';
import { FaDiscord } from 'react-icons/fa';
import HeroSection from '../sections/HeroSection';
import AboutUsSection from '../sections/AboutUsSection';
import TeamSection from '../sections/TeamSection';
import ShowroomSection from '../sections/ShowroomSection';
import SocialsSection from '../sections/SocialsSection';

// Custom X (Twitter) Icon Component
const XIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" style={{ width: '1em', height: '1em', fill: 'currentColor' }}>
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const Home = () => {
  const socialLinks = [
    { name: 'X (Twitter)', url: 'https://x.com/angryaliensally?s=21', icon: <XIcon /> },
    { name: 'Discord', url: 'https://discord.com/invite/yTu6An3jQC', icon: <FaDiscord /> },
  ];

  return (
    <div className="home">
      {/* Top Navigation Buttons */}
      <div className="hero-buttons">
        <Link 
          to="/raffle" 
          className="hero-btn raffle-btn"
          style={{
            background: 'linear-gradient(135deg, #fef7b8 0%, #f9e794 100%)',
            color: '#111c25',
            fontWeight: 'bold',
            border: '4px double #fff',
            boxShadow: '0 0 10px rgba(254, 247, 184, 0.5)'
          }}
        >
          Weekly Raffle
        </Link>
        <a 
          href="https://sentx.io/nft-marketplace/angry-alien-alliance" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="hero-btn kabila-btn"
        >
          Trade on SentX
        </a>
      </div>

      {/* Social Icons - Top Right */}
      <div className="hero-socials">
        {socialLinks.map((social, index) => (
          <a
            key={index}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            className="hero-social-icon"
            style={{ animationDelay: `${0.8 + index * 0.1}s` }}
            aria-label={social.name}
          >
            {social.icon}
          </a>
        ))}
      </div>

      <HeroSection />
      <AboutUsSection />
      <TeamSection />
      <ShowroomSection />
      <SocialsSection />
    </div>
  );
};

export default Home;